import React from "react";
import {
  Typography,
  Link,
  Box,
  CssBaseline,
  AppBar,
  Toolbar,
  IconButton,
  Container,
  Grid,
} from "@mui/material";
import { useParams } from "react-router-dom";
import CryptoJS from "crypto-js";
import Copyright from "./components/Copyright";
import server from "../functions/server";
import Cookies from "js-cookie";

class ConfirmaEmail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resp: "",
      puxando: false,
    };
  }

  render() {
    let email = this.props.params.email;
    let codparc = this.props.params.codparc;

    email = email
      .toString()
      .replaceAll("xMl3Jk", "+")
      .replaceAll("Por21Ld", "/")
      .replaceAll("Ml32", "=");
    email = CryptoJS.AES.decrypt(email, "medsys@341");
    email = CryptoJS.enc.Utf8.stringify(email);

    let url = server + "/portalCliente/atualiza_dados";

    if (!this.state.puxando) {
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + Cookies.get('bearer'),
        },
        body: JSON.stringify({
          jsonid: localStorage.getItem("token"),
          cnpj: localStorage.getItem("user"),
          email: email,
          email_conf: true,
          codparc: codparc,
        }),
      })
        .then((res) => res.text())
        .then((json) => {
          this.setState({ puxando: true, resp: JSON.parse(json) });
        })
        .catch((err) => console.error("error:" + err));
    }

    return (
      <>
        <Box sx={{ display: "flex" }}>
          <CssBaseline />
          <AppBar position="absolute" color="default">
            <Toolbar
              sx={{
                pr: "24px",
              }}
            >
              <Typography
                component="div"
                variant="div"
                color="inherit"
                noWrap
                alignItems="flex-end"
                sx={{ flexGrow: 1, mr: 2, display: { xs: "none", md: "flex" } }}
              >
                <img
                  sx={{ flexGrow: 1 }}
                  alignSelf="flex-end"
                  height={35}
                  src={
                    "https://medsystems.com.br/wp-content/themes/medsystems/assets/images/logo.svg"
                  }
                />
              </Typography>
            </Toolbar>
          </AppBar>
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              overflow: "auto",
            }}
          >
            <Container maxWidth="lg" sx={{ mt: 10, mb: 4 }}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Typography>
                    {this.state.resp.data == "" ? (
                      <>
                        Erro: Realize <a href="/login">login</a> e tente
                        novamente.
                      </>
                    ) : (
                      <>
                        O e-mail cadastrado foi alterado para {email} com
                        sucesso. Você já pode fechar essa janela.
                      </>
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Copyright sx={{ pt: 4 }} />
            </Container>
          </Box>
        </Box>
      </>
    );
  }
}

export default (props) => <ConfirmaEmail {...props} params={useParams()} />;
